/**
 * This is the project spefic playground for certain features which are to be used in the project.
 *
 * Feel free to add new components and test cases over here
 */

import useMeaQuery from "qpr-base/apihooks/useMeaQuery";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import Query from "qpr-base/querybuilder/Query";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { ICardElement, IScoreCard } from "../../backend/model/model";
import ShowCardNavigator from "./Elements";
import ScorecardNavigator from "./Scorecards";
import ShowElementData from "./SingleElement";

const getModels = async () => {
  return Query("SC")
    .models()
    .attributes("name")
    .fetchValues<{ id: string; name: string }>();
};

const getScorecards = async () => {
  return Query("SC")
    .models()
    .scorecard()
    .attributes("name")
    .fetchValues<{ id: string; name: string }>();
};

const ShowModels = () => {
  const { isLoading, data } = useQuery("models", () => getModels());
  return <div>{!isLoading ? <div>{JSON.stringify(data)}</div> : null}</div>;
};

const ShowScorecards = () => {
  const { isLoading, data } = useQuery("scorecards", () => getScorecards());
  return (
    <div>{!isLoading ? <pre>{JSON.stringify(data, null, 2)}</pre> : null}</div>
  );
};

/*
  const searchResults = useMeaQuery<SearchResult[]>(
    String.raw`[${modelId}].subobjects(recursive=1, criteria="hasreferencescorecard=\"0\" AND Find(\"${searchKeyword}\", LOWER(measure.value(series=\"JS_ATTR\", period=\"Q1 / 2010\")))")`,
    String.raw`name, symbol, rangevalue, typename, value(period="${ctx.period}",as="performance"), rangecolor(period="${ctx.period}"), value(series="JS_ATTR", period="firstforseries",as="translations"), related(relation=parentObjects, as="parent_id")`,
    undefined,
    {
      ...options,
      enabled: !!modelId && !isThemeLoading && !navi.isLoading
    }
  );
*/
export type SearchResult = {
  id: string;
  name: string;
  typename: string;
  performance: string;
  rangecolor: string;
  JS_ATTR: string;
  parent_id: string;
  rangevalue?: string;
};
const useSearch = (keyword: string) => {
  const ctx = useAppContext();

  const { data, isLoading } = useMeaQuery<SearchResult[]>(
    String.raw`[${
      ctx.fullModelId || ""
    }].subobjects(recursive=1, criteria="hasreferencescorecard=\"0\" AND Find(\"${keyword.toLocaleLowerCase()}\", LOWER(measure.value(series=\"JS_ATTR\", period=\"firstforseries\")))")`,
    String.raw`name, symbol, rangevalue, typename, value(period="${ctx.period}",as="performance"), rangecolor(period="${ctx.period}"), value(series="JS_ATTR", period="firstforseries"), related(relation=parentObjects, as="parent_id")`,
    undefined,
    {
      enabled: true,
    }
  );
};

const Playground = () => {
  const ctx = useAppContext();
  const { isLoading, data } = useQuery("models", () => getModels());
  const [scorecard, setScorecard] = useState<null | IScoreCard>(null);
  const [element, setElement] = useState<null | ICardElement>(null);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        gap: "30px",
      }}
    >
      <div>Model: {ctx.modelId}</div>
      <div style={{ width: "200px" }}>
        <ScorecardNavigator
          onSelect={(s) => {
            setScorecard(s);
            setElement(null);
          }}
        />
      </div>
      <div>
        {scorecard ? (
          <ShowCardNavigator
            card={scorecard}
            onSelect={(e) => {
              setElement(e);
            }}
          />
        ) : null}
      </div>
      <div>{element ? <ShowElementData card={element} /> : null}</div>
    </div>
  );
};

export default Playground;
